// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"2833222c","238":"a9acad9b","386":"ab42189a","416":"b1abfeb9","456":"728f3e87","635":"86b476a4"}[chunkId] + ".chunk.css";
};